import script from "./StudyRequirementRecap.vue?vue&type=script&setup=true&lang=js"
export * from "./StudyRequirementRecap.vue?vue&type=script&setup=true&lang=js"

import "./StudyRequirementRecap.vue?vue&type=style&index=0&id=db559bb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db559bb2"]])

export default __exports__